import { render, staticRenderFns } from "./OnboardingEmptyPlaceholder.vue?vue&type=template&id=6311740c&"
import script from "./OnboardingEmptyPlaceholder.vue?vue&type=script&lang=js&"
export * from "./OnboardingEmptyPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports